<div class="container-fluid p-0 m-0">
    <app-shared status="Négociation"></app-shared>
</div>
